import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import ReactSwitch from "react-switch";
import {
  getStudentInvoiceAggregate,
  getStudentInvoiceDetail,
  getStudentInvoices,
  getAllUnpaidInvoice,
} from "../../../actions/emActions";
import ChangeTime from "../../teacherComponents/ClassStart/ChangeTime";
import InvoiceDesign from "../../website/InvoiceDesign";
import emptyImage from "../../../public/images/empty.svg";
import { imageLink } from "../../../actions/utility";
import AggregateInvoiceDesign from "../../website/AggregateInvoiceDesign";
import UnpaidInvoiceDesign from "../../website/UnpaidInvoiceDesign";
import {PaymentElement} from '@stripe/react-stripe-js';
import CheckoutForm from "./CheckoutForm";

const Invoices = ({ studentId }) => {
  const [allInvoices, setallInvoices] = useState([]);
  const [aggregateInvoice, setaggregateInvoice] = useState([]);
  const [unpaidInvoices, setunpaidInvoices] = useState([]);
  const [invoiceDetails, setinvoiceDetails] = useState({});
  const [invoiceData, setinvoiceData] = useState({});
  const [invoiceId, setinvoiceId] = useState(0);
  const [invoiceTab, setinvoiceTab] = useState(1);
  const [unpaidAmount, setunpaidAmount] = useState(0);

  useEffect(() => {
    getAllUnpaidInvoice(studentId).then((res) => {
      setunpaidInvoices(res.data.unpaidInvoices);
      const totalAmount = res?.data?.unpaidInvoices.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.amount_payable;
      }, 0);
      setinvoiceTab(totalAmount === 0 ? 1 : 3);
    });
    getStudentInvoices(studentId).then((res) => {
      setallInvoices(res.data.invoices);
      setinvoiceData(res.data);
    });
    getStudentInvoiceAggregate(studentId).then((res) => {
      setaggregateInvoice(res.data.invoices);
    });
  }, []);

  useEffect(() => {
    if (invoiceId !== 0) {
      getStudentInvoiceDetail(invoiceId).then((res) => {
        debugger;
        setinvoiceDetails(res?.data);
      });
    }
  }, [invoiceId]);

  const totalAmount = (data) => {
    const totalAmount = data.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.amount_payable;
    }, 0);
    return totalAmount;
  };

  const unPaidAmount = () => {
    const totalAmount = unpaidInvoices.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.amount_payable;
    }, 0);
    return totalAmount;
  };

  const formatTime = (time) => {
    return time.slice(0, -2) + " " + time.slice(-2);
  };
  return (
    <div className="row" id="accordionForInvoices">
      <div className="col-md-12">
      {/* <CheckoutForm /> */}
        <label className="font-weight-bold">Invoice Information:</label>
        <br />

        <div className="d-flex justify-content-center">
          <div className="InvoiceBox">
            <div className="text-center">
              <label className="mb-0 ">
                {" "}
                <span className="paid">{invoiceData.payed}</span> Invoices paid{" "}
              </label>

              <p className="font-weight-bold mb-0 paid">Rs {invoiceData.payedAmount && Number(invoiceData.payedAmount).toLocaleString()}</p>
            </div>
          </div>
          <div className="InvoiceBox">
            <div className="text-center">
              <label className="mb-0">
                <span className="cancelled">{invoiceData.cancelled}</span> Invoices cancelled{" "}
              </label>

              <p className="font-weight-bold mb-0 cancelled">Rs {invoiceData.canelledAmount && Number(invoiceData.canelledAmount).toLocaleString()}</p>
            </div>
          </div>
          <div className="InvoiceBox">
            <div className="text-center">
              <label className="mb-0">
                <span className="unpaid">{invoiceData.unpayed}</span> Invoices unpaid{" "}
              </label>

              <p className="font-weight-bold mb-0 unpaid">Rs {invoiceData.unpayedAmount && Number(invoiceData.unpayedAmount).toLocaleString()}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-12 mt-2 mb-2">
        {unPaidAmount() !== 0 && (
          <button
            className={invoiceTab === 3 ? "activeBtn" : "inActiveBtn"}
            onClick={() => setinvoiceTab(3)}
          >
            Total Amount Owed
          </button>
        )}
        <button
          className={invoiceTab === 1 ? "activeBtn" : "inActiveBtn"}
          onClick={() => setinvoiceTab(1)}
        >
          Monthly Invoices
        </button>
        <button
          className={invoiceTab === 2 ? "activeBtn" : "inActiveBtn"}
          onClick={() => setinvoiceTab(2)}
        >
          Aggregate Invoices
        </button>
        <hr />
      </div>

      {invoiceTab === 1 ? (
        <>
          <div className="col-md-12">
            <label className="font-weight-bold">All Invoices:</label>
          </div>

          {allInvoices &&
            allInvoices.map((item, index) => (
              <div className="col-md-12 mt-2" key={item?.id}>
                <div
                  className="registeredCourses d-flex justify-content-between"
                  data-toggle="collapse"
                  data-target={`#One${index}`}
                  aria-expanded="true"
                  aria-controls="collapseOne"
                  onClick={() => setinvoiceId(item?.id)}
                >
                  <div className="invoiceUpperSection">
                    <label className="m-auto">{item?.lm_course?.course_name} </label>
                    <div className="teacherSection d-flex">
                      {item?.lm_program?.lm_assign_program?.[0]?.teacher_nu_users?.user_name &&
                      <div>
                        <img
                          className="smallAvatar"
                          src={
                            item?.lm_program?.lm_assign_program &&
                            item?.lm_program?.lm_assign_program[0]?.teacher_nu_users !== null
                              ? imageLink(
                                  item?.lm_program?.lm_assign_program[0]?.teacher_nu_users?.image
                                )
                              : emptyImage
                          }
                        />
                      </div>}
                      {item?.lm_program?.lm_assign_program?.[0]?.teacher_nu_users?.user_name && (
                        <label className="teacherName my-auto">
                          Taught By&nbsp;
                          {item?.lm_program?.lm_assign_program[0]?.teacher_nu_users?.user_name}
                        </label>
                      )}
                    </div>
                  </div>

                  <div className="invoiceLastSection">
                    <span className="text-muted">
                      {moment(item.release_date).format("Do MMM YY")}
                    </span>{" "}
                    {item.status == 1 || item.status == 2 ? (
                      <>
                        <label className="mr-3 text-success font-weight-bold">
                          PKR {item?.amount_payable ? Number(item?.amount_payable).toLocaleString() : 0}
                        </label>
                        <button className="invoicePaid">Paid</button>
                      </>
                    ) : item.status == 3 ? (
                      <>
                        <label className="mr-3 cancelled font-weight-bold">
                        PKR {item.amount_payable ? Number(item?.amount_payable).toLocaleString() : 0}
                        </label>
                        <button className="invoiceCancelled">Cancelled</button>
                      </>
                    ) : item.status == 0 ? (
                      <>
                        <label className="mr-3 text-danger font-weight-bold">
                        PKR {item.amount_payable ?  Number(item?.amount_payable).toLocaleString() : 0}
                        </label>
                        <button className="invoiceUnpaid">Unpaid</button>
                      </>
                    ) : null}
                    <i className="fa fa-chevron-down text-muted"></i>
                  </div>
                </div>

                <div
                  id={`One${index}`}
                  className="collapse accordionBox"
                  aria-labelledby="headingOne"
                  data-parent="#accordionForInvoices"
                >
                  <InvoiceDesign invoiceDetails={invoiceDetails}  />
                </div>
              </div>
            ))}
        </>
      ) : invoiceTab === 2 ? (
        <>
          <div className="col-md-12">
            <label className="font-weight-bold">Aggregate Invoices:</label>
          </div>

          {aggregateInvoice &&
            Object.keys(aggregateInvoice).map((item, index) => (
              <div className="col-md-12 mt-2">
                <div
                  className="registeredCourses d-flex justify-content-between"
                  data-toggle="collapse"
                  data-target={`#One${index}`}
                  aria-expanded="true"
                  aria-controls="collapseOne"
                  // onClick={() => setinvoiceId(item?.id)}
                >
                  <div className="d-flex">
                    <label className="m-auto">
                      <span className="text-muted">Monthly Invoice of</span> {item}
                    </label>
                  </div>
                  <div>
                    <span>Total Amount: </span>
                    <label className="mr-3 font-weight-bold">
                      PKR {Number(totalAmount(aggregateInvoice[item])).toLocaleString()}
                    </label>
                    {/* <button className="invoicePaid">Paid</button> */}
                  </div>

                  {/* <div>
                    <span className="text-muted text-left mr-3">
                      {moment(item.release_date).format("Do MMMM YY")} -
                    </span>{" "}
                    {item.status == 1 || item.status == 2 ? (
                      <>
                        <label className="mr-3 text-success font-weight-bold">
                          Rs {item.amount_payable ? item.amount_payable : 0}
                        </label>
                        <button className="invoicePaid">Paid</button>
                      </>
                    ) : item.status == 3 ? (
                      <>
                        <label className="mr-3 cancelled font-weight-bold">
                          Rs {item.amount_payable}
                        </label>
                        <button className="invoiceCancelled">Cancelled</button>
                      </>
                    ) : item.status == 0 ? (
                      <>
                        <label className="mr-3 text-danger font-weight-bold">
                          Rs {item.amount_payable}
                        </label>
                        <button className="invoiceUnpaid">Unpaid</button>
                      </>
                    ) : null}
                    <i className="fa fa-chevron-down ml-5 text-muted"></i>
                  </div> */}
                </div>

                <div
                  id={`One${index}`}
                  className="collapse accordionBox"
                  aria-labelledby="headingOne"
                  data-parent="#accordionForInvoices"
                >
                  <AggregateInvoiceDesign invoiceDetails={aggregateInvoice[item]} />
                </div>
              </div>
            ))}
        </>
      ) : invoiceTab === 3 ? (
        <UnpaidInvoiceDesign invoiceDetails={unpaidInvoices} />
      ) : null}
    </div>
  );
};

export default Invoices;
